import { setTakeOffPoint, setLandingPoint } from '../../api/Missions/mission-methods-client';

import { latlong2featurePoint } from '../geojson-utilities';
import handleErrorInClient from '../handle-error-in-client';
import updateLandingInWaypointList from './updateLandingInWaypointList';
import updateTakeOffInWaypointList from './updateTakeOffInWaypointList';

/**
 * When the map is clicked, if the take off or landing buttons are active, these waypoints are updated.
 *
 * @async
 * @callback
 * @param {*} arg - The object argument.
 * @param {object} arg.event - The event fired after clicking the map.
 * @param {Function} arg.getCurrentMapState - A function that gets the current variables needed from the map component.
 */
const onClickOnMap = async ({ event, getCurrentMapState }) => {
  const {
    takeOffPointActive,
    landingPointActive,
    mission,
    geoJSONTakeOffPointLayer,
    geoJSONLandingPointLayer,
    startElevationProgressBar,
    cancelElevationProgress
  } = getCurrentMapState();
  if (takeOffPointActive) {
    const newTakeOffPoint = latlong2featurePoint(event.latlng.wrap());
    newTakeOffPoint.properties = {
      type: 1,
      altAbsolute: 50,
      altGround: -999,
      totalNumber: 0,
      distanceTraveled: 0
    };
    geoJSONTakeOffPointLayer.clearLayers();
    try {
      await updateTakeOffInWaypointList({
        myTakeOffPoint: newTakeOffPoint,
        startElevationProgressBar,
        cancelElevationProgress,
        mission
      });
      setTakeOffPoint(mission._id, newTakeOffPoint);
    } catch (error) {
      handleErrorInClient(error);
    }
  }

  if (landingPointActive) {
    const newLandingPoint = latlong2featurePoint(event.latlng.wrap());
    newLandingPoint.properties = {
      type: 2,
      altAbsolute: 0,
      altGround: -999
    };
    geoJSONLandingPointLayer.clearLayers();
    try {
      await updateLandingInWaypointList({
        myLandingPoint: newLandingPoint,
        startElevationProgressBar,
        cancelElevationProgress,
        mission
      });
      setLandingPoint(mission._id, newLandingPoint);
    } catch (error) {
      handleErrorInClient(error);
    }
  }
};

export default onClickOnMap;
